const ID = 'share';

export default ID;
